module.exports = __webpack_public_path__ + "media/homepage/student-deals-b178ec5b.webp";